module.exports = __webpack_public_path__ + "img/03n.f65122a6.png";